export const feedbackMessages = {
  SUCCESS_BEACON_EDITED: {
    variant: 'success',
    title: 'Beacon Edited Successfully',
    copy: 'The beacon has been successfully edited.',
    buttonMessage: 'Continue',
  },
  ERROR_BEACON_EDIT: {
    variant: 'error',
    title: 'Unable to Edit Location',
    copy: "We couldn't edit the beacon. Please try again or contact support if the issue persists.",
    buttonMessage: 'Continue',
  },
  SUCCESS_BEACON_ADDED: {
    variant: 'success',
    title: 'Beacon Added Successfully',
    copy: 'The beacon has been successfully added to the list.',
    buttonMessage: 'Continue',
  },
  ERROR_BEACON_ADD: {
    variant: 'error',
    title: 'Unable to Assign Location',
    copy: "We couldn't assign the location to the beacon. Please try again or contact support if the issue persists.",
    buttonMessage: 'Continue',
  },
  SUCCESS_BEACON_DELETE: {
    variant: 'success',
    title: 'Location Association Deleted Successfully',
    copy: 'The location association for the beacon has been successfully deleted.',
    buttonMessage: 'Continue',
  },
  ERROR_DELETE_ASSOCIATION: {
    variant: 'error',
    title: 'Unable to Delete Location Association',
    copy: "We couldn't delete the location association. Please try again or contact support if the issue persists.",
    buttonMessage: 'Continue',
  },
  ERROR_FETCH_ORGANIZATIONS: {
    variant: 'error',
    copy: "We couldn't retrieve the Organizations.",
    buttonMessage: 'Retry',
  },
  ERROR_FETCH_FACILITIES: {
    variant: 'error',
    copy: "We couldn't retrieve the Facilities.",
    buttonMessage: 'Retry',
  },
  ERROR_FETCH_BEACONS: {
    variant: 'error',
    copy: "We couldn't retrieve the Locations.",
    buttonMessage: 'Retry',
  },
};

export default feedbackMessages;
